
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { UserRole } from "@/types/auth";

export const useUserProfile = () => {
  const [userRole, setUserRole] = useState<UserRole | null>(null);

  const fetchUserProfile = async (userId: string) => {
    try {
      const { data, error } = await supabase
        .from("profiles")
        .select("role")
        .eq("id", userId)
        .single();
      
      if (error) throw error;
      
      if (data) {
        setUserRole(data.role as UserRole);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  return {
    userRole,
    setUserRole,
    fetchUserProfile,
  };
};
